import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { cn } from "@repo/ui/utils";
const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

/**
 * Placeholder shown in the alphabet bar's slot while the `firstLetter` facet
 * loads (it isn't part of the SSR response). Matches the bar's dimensions so
 * the real bar replaces it without shifting the page.
 */
export function DirectoryAlphabetBarSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden={true} className="col-span-full overflow-x-auto desktop:overflow-x-visible"><div className="flex items-center gap-2">{LETTERS.map(_temp)}</div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(letter) {
  return <div key={letter} className="h-10 min-w-10 flex-1 animate-pulse rounded-[2px] bg-surface-base-secondary" />;
}
interface DirectoryAlphabetBarProps {
  activeLetter: string | null;
  onLetterSelect: (letter: string | null) => void;
  availableLetters: string[];
}
export function DirectoryAlphabetBar({
  activeLetter,
  onLetterSelect,
  availableLetters
}: DirectoryAlphabetBarProps) {
  const visibleLetters = useMemo(() => {
    const set = new Set(availableLetters.map(l => l.toUpperCase()));
    const filtered = LETTERS.filter(letter => set.has(letter));
    return filtered.length > 0 ? filtered : LETTERS;
  }, [availableLetters]);
  return <div className="col-span-full overflow-x-auto desktop:overflow-x-visible">
      <div className="flex items-center gap-2">
        {visibleLetters.map(letter_0 => <button key={letter_0} type="button" onClick={() => onLetterSelect(activeLetter === letter_0 ? null : letter_0)} className={cn("flex h-10 min-w-10 flex-1 cursor-pointer items-center justify-center rounded-[2px] border typography-component-xs-medium transition-colors", activeLetter === letter_0 ? "border-surface-brand-primary bg-button-primary-background text-white" : "border-border-subtle bg-white text-text-primary hover:bg-surface-base-secondary")} aria-pressed={activeLetter === letter_0}>
            {letter_0}
          </button>)}
      </div>
    </div>;
}